import { useTranslation } from '@msdk/common'
import { DocumentContent } from 'components/SideMenu/DocumentContent'
import { useEffect } from 'react'
import { useWizard } from 'react-use-wizard'
import { useDocuments } from 'state/documents'

import { FooterPopup } from './FooterPopup'
import { HeaderPopup } from './HeaderPopup'
import { ModalStepProps, StyledContent } from './shared'

interface PrivacyNoticePopupProps extends ModalStepProps {
  onSetCustomWidth: (width: number | undefined) => void
}

export function PrivacyNoticePopup({ onSetCustomWidth, ...props }: PrivacyNoticePopupProps) {
  const t = useTranslation()
  const { previousStep, goToStep } = useWizard()

  useEffect(() => {
    onSetCustomWidth(890)
    return () => onSetCustomWidth(undefined)
  }, [onSetCustomWidth])

  const handleStep = async () => {
    goToStep(5)
  }
  const documents = useDocuments()
  const privacyDoc = documents.find((x) => x.fields['TYPE']?.value == 'PRV_FACE_RECO')
  const file = privacyDoc?.fields['FILE']?.value as string
  return (
    <>
      <HeaderPopup
        title={t('LBL_NGID_PRIVACY_FACE_RECO_TITLE', 'Privacy notice for face recognition')}
        modalRef={props.modalRef}
      />
      <StyledContent>
        {privacyDoc && <DocumentContent entityName={privacyDoc.entityName} entityId={privacyDoc.id} file={file} />}
        {!privacyDoc && <p>{t('LBL_NGID_PRIVACY_FACE_RECO_ERROR', 'Privacy document not present')}</p>}
      </StyledContent>
      <FooterPopup
        secondary={{ label: t('LBL_NGID_CANCEL_BTN', 'Cancel'), onClick: previousStep }}
        primary={{ label: t('LBL_NGID_ACCEPT_BTN', 'Accept'), onClick: handleStep }}
      />
    </>
  )
}
